import { render, staticRenderFns } from "./History.vue?vue&type=template&id=4e5c1c5c&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"
import style0 from "./History.vue?vue&type=style&index=0&id=4e5c1c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c1c5c",
  null
  
)

export default component.exports